// De KPI-iconen als vormen, EEN bron voor de app en het kantoorscherm.
//
// De app tekent ze via MenuIcon / RailIcon / NAV_ICON_PATHS / EntityIcon in
// components/HomeV2/lib.js (die lezen deze vormen), het kantoorscherm krijgt ze als
// SVG-tekst mee met de bordcijfers (app/api/dealtune/board, kpiIcons), want
// public/screen.html kan niets importeren. Wijzig een icoon HIER, dan volgen app en
// muur samen; lib/kpi-icons.test.mjs bewaakt dat er geen tweede tekening ontstaat.
//
// Vorm = [tag, attributen], viewBox 0 0 24 24, lijnwerk (stroke, geen fill).
import { BRANCH_PATHS } from './partnerbook-icons.mjs';

export const CALLS_PATH = 'M21.5 17.4v2.4a1.8 1.8 0 0 1-2 1.8 17.8 17.8 0 0 1-7.7-2.8 17.5 17.5 0 0 1-5.4-5.4A17.8 17.8 0 0 1 3.6 5.7a1.8 1.8 0 0 1 1.8-2h2.4a1.8 1.8 0 0 1 1.8 1.6c.1.9.3 1.7.6 2.5a1.8 1.8 0 0 1-.4 1.9l-1 1a14.4 14.4 0 0 0 5.4 5.4l1-1a1.8 1.8 0 0 1 1.9-.4c.8.3 1.6.5 2.5.6a1.8 1.8 0 0 1 1.5 1.8z';

// CV Send: document met pijl naar rechts (eigenaarsbesluit 5 okt 2026). EEN
// tekening voor elke plek die een CV Send bedoelt: menu, rasters, matrices,
// toasts, monitor. Een papieren vliegtuig betekent alleen nog generiek versturen;
// lib/cvsend-glyph.test.mjs bewaakt dat.
export const CV_SEND_PATHS = ['M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6', 'M14 3v5h5', 'M14 15h7M18 12l3 3-3 3'];
// Dezelfde vorm als een d-string, voor tabellen die per icoon een enkel pad tekenen.
export const CV_SEND_D = CV_SEND_PATHS.join(' ');

export const KPI_ICON_SHAPES = {
  calls: [['path', { d: CALLS_PATH }]],
  // NTP (niet te pakken, een belpoging zonder gesprek): de handset van calls met een
  // kruis rechtsboven (teambalk, 14 okt 2026).
  ntp: [['path', { d: CALLS_PATH }], ['path', { d: 'M15 3l6 6M21 3l-6 6' }]],
  cvSend: CV_SEND_PATHS.map((d) => ['path', { d }]),
  interview: [['rect', { x: 3, y: 4, width: 18, height: 18, rx: 2 }], ['path', { d: 'M16 2v4M8 2v4M3 10h18' }], ['path', { d: 'M9 16l2 2 4-4' }]],
  plaatsing: BRANCH_PATHS.map((d) => ['path', { d }]),
  omzet: [['circle', { cx: 15, cy: 12, r: 5.5 }], ['path', { d: 'M12 7.4A5.5 5.5 0 0 0 12 16.6' }]],
};

const escAttr = (v) => String(v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');

// SVG-tekst voor het kantoorscherm. currentColor, zodat het icoon de kleur van de
// kolomkop volgt.
export function kpiIconSvg(key, { strokeWidth = 1.9 } = {}) {
  const shapes = KPI_ICON_SHAPES[key];
  if (!shapes) return '';
  const inner = shapes.map(([tag, attrs]) =>
    '<' + tag + Object.entries(attrs).map(([k, v]) => ' ' + k + '="' + escAttr(v) + '"').join('') + '/>').join('');
  return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + strokeWidth
    + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + inner + '</svg>';
}

export function kpiIconsForScreen() {
  const out = {};
  for (const k of Object.keys(KPI_ICON_SHAPES)) out[k] = kpiIconSvg(k);
  return out;
}
